<template>
  <div class="Panel">
    
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Ostatnie pomiary
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          
          <div class="table-container">

           <table class="table is-bordered is-narrow">
                <thead>
                    <tr class="tableheader">
                        
                        <td colspan="2">Odczyt</td>
                        <td colspan="5">Temperatury</td>
                        
                    </tr>    
                    <tr  class="tableheadersub">
                        <td>Adres</td>
                        <td>Data</td>

                        <td>CW - zasilanie</td>
                        <td>CW - cyrkulacja</td>
                        <td>CO - zasilanie</td>
                        <td>CO - powrót</td>
                        <td>Kotły</td>

                    </tr>
                </thead>

                <tbody v-for="el in datas" v-bind:key="el.id">
                    <tr>
                        <td>{{el.title}}</td>

                        <td>
                          <span  v-if="el.red==true" class="red">{{el.date}}</span>
                          <span  v-if="el.red==false" >{{el.date}}</span>
                        </td>
                        <td>
                          <span  v-if="el.red==true" class="red">{{el.t1}}</span>
                          <span  v-if="el.red==false" >{{el.t1}}</span>
                        </td>
                        <td>
                          <span  v-if="el.red==true" class="red">{{el.t2}}</span>
                          <span  v-if="el.red==false" >{{el.t2}}</span>
                        </td>
                        <td>
                          <span  v-if="el.red==true" class="red">{{el.t3}}</span>
                          <span  v-if="el.red==false" >{{el.t3}}</span>
                        </td>
                        <td>
                          <span  v-if="el.red==true" class="red">{{el.t4}}</span>
                          <span  v-if="el.red==false" >{{el.t4}}</span>
                        </td>
                        <td>
                          <span  v-if="el.red==true" class="red">{{el.t5}}</span>
                          <span  v-if="el.red==false" >{{el.t5}}</span>
                        </td>
                    </tr>    
                    

                </tbody>
                     

                <tfoot>
                    <tr>
                        <td></td>
                        <td class="avgtemp"><b>Średnia temperatura:</b></td>
                        <td><b>{{avg_t1}}</b></td>
                        <td><b>{{avg_t2}}</b></td>
                        <td><b>{{avg_t3}}</b></td>
                        <td><b>{{avg_t4}}</b></td>
                        <td><b>{{avg_t5}}</b></td>
                    </tr> 
                </tfoot>    




           </table>
            
            
            
          </div>
        </div>
      </div>

      
    </div>
    
   
  </div>
</template>

<script>





export default {
  name: 'LastMeasure',
  components: {
    
   

  },
  computed: {
    datenow(){
      let now = Date.now();

      return now
    },
    avg_t1(){

      let avg = 0;
      let lei = this.datas.length;
      let counter = 0;
      for (let i = 0; i < lei; i++){
        
        if (this.datas[i].red != true){
            avg = avg + parseFloat(this.datas[i].t1);
            counter++;
        }
       }
      
      avg = Math.floor((avg/counter)*100)/100;
      return avg;
    },
    avg_t2(){

      let avg = 0;
      let lei = this.datas.length;
      let counter = 0;
      for (let i = 0; i < lei; i++){
        
        if (this.datas[i].red != true){
            avg = avg + parseFloat(this.datas[i].t2);
            counter++;
        }
       }
      
      avg = Math.floor((avg/counter)*100)/100;
      return avg;
    } ,
    avg_t3(){

      let avg = 0;
      let lei = this.datas.length;
      let counter = 0;
      for (let i = 0; i < lei; i++){
        
        if (this.datas[i].red != true){
            avg = avg + parseFloat(this.datas[i].t3);
            counter++;
        }
       }
      
      avg = Math.floor((avg/counter)*100)/100;
      return avg;
    } ,
    avg_t4(){

      let avg = 0;
      let lei = this.datas.length;
      let counter = 0;
      for (let i = 0; i < lei; i++){
        
        if (this.datas[i].red != true){
            avg = avg + parseFloat(this.datas[i].t4);
            counter++;
        }
       }
      
      avg = Math.floor((avg/counter)*100)/100;
      return avg;
    } ,
    avg_t5(){

      let avg = 0;
      let lei = this.datas.length;
      let counter = 0;
      for (let i = 0; i < lei; i++){
        
        if (this.datas[i].red != true){
            avg = avg + parseFloat(this.datas[i].t5);
            counter++;
        }
       }
      
      avg = Math.floor((avg/counter)*100)/100;
      return avg;
    }   
    
  },
  props: {
    
    
  },
  data() {
    return {
      datas: [
        {id: 0, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "77D", date: ""},
        {id: 8, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "78", date: ""},
        {id: 1, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "79", date: ""},
        {id: 7, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "84", date: ""},
        {id: 6, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "91", date: ""},
        {id: 2, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "91A", date: ""},
        {id: 3, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "91B", date: ""},
        {id: 4, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "91C", date: ""},
        {id: 5, t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, title: "91D", date: ""},
      ]
      
    }
    
  },
  mounted () {

    for (let i = 0, lei = this.datas.length; i < lei; i++ ){
        
        let objData = {
            id: this.datas[i].id,
        
        }
                
        this.$store.dispatch('getLast', objData)
        .then(response => {
            
                        
          this.buildForm(response.nid, response.data[0])
        })
        .catch(error => {
            console.log("Error:")
            console.log(error)
            return error
        });
    

    }

    
  },
  methods: {
    buildForm(nid, _data){
        for (var i = 0, lei = this.datas.length; i < lei; i++){
          
          if (this.datas[i].id == nid){
            this.datas[i].t1 = _data.t1;  
            this.datas[i].t2 = _data.t2;      
            this.datas[i].t3 = _data.t3;      
            this.datas[i].t4 = _data.t4;      
            this.datas[i].t5 = _data.t5; 
            this.datas[i].date = _data.date;        
            
            var a = new Date(this.datenow);
            var b = new Date(_data.date)
                        
            var dif = b - a;
            var day = 1000 * 60 * 60 * 23;
            

            if (dif > -day){
              
              this.datas[i].red = false;
            }else{
              
              this.datas[i].red = true;
            }
            
          }
          
        
      }

    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tableheader{
        background-color:#e3e3e3;
        
    }
    .tableheadersub{
        background-color:#f5f5f5;
        
    }
    table thead tr td{
      text-align: center;
    }
    table tbody tr td{
      text-align: center;
    }
    table tfoot tr td{
      text-align: center;
      background-color:#f5f5f5;
    }
    .avgtemp{
      text-align: right;
    }
    .green{
      color: #00cc00;
    }
    .red{
      color: #cc0000;
    }
 
</style>
